module.exports = __webpack_public_path__ + "static/Pit_Fiend-a1f9ed899450b030d275b3b62c87ab5a.jpg";